/**
 * Created by lenovo on 2017/3/14.
 */
import React,{Component} from 'react'
import {Link} from 'react-router'
export default class BoxHeader extends Component{
    render(){
        return (
            <div className="box-header with-border">
                <i className="fa fa-plus-circle"></i>
                <h3 className="box-title">{this.props.name}</h3>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/boxHeaderCreate.js